module.exports = __webpack_public_path__ + "img/tibet.c7eb078a.svg";